// 迎新模块
export default [
  {
    path: '/welcomeNewStudent/plant',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/plant.vue'], resolve),
    name: 'plant',
    meta: {
      title: '迎新计划'
    }
  },
  {
    path: '/welcomeNewStudent/orientation-schedule',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/orientationSchedule.vue'], resolve),
    name: 'orientation-schedule',
    meta: {
      title: '迎新日程'
    }
  },
  {
    path: '/welcomeNewStudent/plant/detail',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/plantDetail.vue'], resolve),
    name: 'plantDetail',
    meta: {
      title: '迎新计划详情'
    }
  },
  {
    path: '/welcomeNewStudent/plant/detail/process',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/wsProcessSearch.vue'], resolve),
    name: 'wsProcessSearch',
    meta: {
      title: '迎新进度搜索'
    }
  },
  {
    path: '/welcomeNewStudent/plant/detail/birthday-data',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/birthdayData.vue'], resolve),
    name: 'birthday-data',
    meta: {
      title: '生日数据采集'
    }
  },
  {
    path: '/welcomeNewStudent/plant/detail/wsLink',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/wsLink.vue'], resolve),
    name: 'wsLink',
    meta: {
      title: '迎新环节查询'
    }
  },
  {
    path: '/welcomeNewStudent/wsDataApproval',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/wsDataApproval.vue'], resolve),
    name: 'wsLink',
    meta: {
      title: '迎新数据审批'
    }
  },
  {
    path: '/student/newStudentData',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/newborn/newStudentData.vue'], resolve),
    name: 'newStudentWorkManage',
    meta: {
      title: '新生数据管理'
    }
  },
  {
    path: '/student/newStudentDorm',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/newborn/newStudentDorm.vue'], resolve),
    name: 'newStudentDorm',
    meta: {
      title: '新生寝室管理'
    }
  },
  {
    path: '/student/newStudentClass',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/newborn/newStudentClass.vue'], resolve),
    name: 'newStudentClass',
    meta: {
      title: '新生班级管理'
    }
  },
  {
    path: '/student/manageClass',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/newborn/manageClass.vue'], resolve),
    name: 'manageClass',
    meta: {
      title: '管理新生班级'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/welcomeNewStudent.js